import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";

type StyledSidePanelProps = {
  $visible: boolean;
};

export const StyledOverlay = styled.div<StyledSidePanelProps>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${theme.colors.black};
  opacity: ${({ $visible }) => ($visible ? 0.1 : 0)};
  pointer-events: ${({ $visible }) => ($visible ? "auto" : "none")};
  transition: opacity 0.2s ease-in-out;
  z-index: 3;
`;

export const StyledSidePanel = styled.div<StyledSidePanelProps>`
  border-radius: ${theme.variables.border_radius_1} 0 0
    ${theme.variables.border_radius_1};
  background-color: white;
  width: ${theme.variables.filter_panel_width};
  position: fixed;
  right: ${({ $visible }) => ($visible ? 0 : "-100%")};
  top: 0;
  height: 100%;
  box-sizing: border-box;
  z-index: 4;
  -moz-transition: all 0.2s;
  -webkit-transition: all 0.2s;
  -o-transition: all 0.2s;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: ${theme.variables.side_panel_box_shadow};
  @media (max-width: ${({ theme }) => theme.breakpoints.SM}px) {
    width: 100%;
  }

  & .panel-header {
    display: flex;
    flex-direction: column;
    padding: 20px;
    box-sizing: border-box;
    gap: 20px;
  }

  & .panel-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
  }

  & .panel-footer {
    padding: 20px;
    box-sizing: border-box;
    border-top: 1px solid ${theme.colors.purple_2};
    align-content: center;
    justify-items: center;
  }

  & .panel-loader {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;
